import sortBy from 'lodash/sortBy';

import { ComponentColumn } from '../component.constants';
import { ComponentViewWrapper } from '../components-view-wrapper.style';
import ComponentPreviewComponents from '../component-preview-components';
import { ColumnWrapper } from './columns.style';
import {
  getAppliedColour,
  isBackgroundApplied,
  isBorderApplied,
} from 'approot/activity-builder/components/shared/component-settings-borders.utils';
import { getStyleProperties } from 'approot/activity-builder/components/components.utils';

type Props = {
  column: ComponentColumn;
};

const ColumnsComponentsPreview = ({ column }: Props) => {
  const sortedComponents = sortBy(column.components, 'sort');

  return (
    <ColumnWrapper>
      {sortedComponents.map(component => {
        return (
          <ComponentViewWrapper
            key={component.id}
            $colours={getAppliedColour(getStyleProperties(component))}
            $showBorder={isBorderApplied(getStyleProperties(component))}
            $showBackground={isBackgroundApplied(getStyleProperties(component))}
          >
            <ComponentPreviewComponents component={component} />
          </ComponentViewWrapper>
        );
      })}
    </ColumnWrapper>
  );
};

export default ColumnsComponentsPreview;
